import { useFeatureFlag } from '@spotify/confidence-flag-evaluation-react';

import { useIntercom } from './useIntercom';
import { useUnthread } from './useUnthread';

type SupportMessengerVariant = 'unthread' | 'fin' | 'agent';

export interface SupportMessenger {
  openChat: (user?: { name: string; email: string }) => void;
  closeChat: () => void;
  toggleChat: () => void;
  openChatWithMessage: (
    message: string,
    user?: { name: string; email: string },
  ) => void;
  variant: SupportMessengerVariant;
}

const noop = () => {};

export const useSupportMessenger = (): SupportMessenger => {
  const messenger = useFeatureFlag<SupportMessengerVariant>(
    'support-messenger.messenger',
    'unthread',
  );

  const isUnthread = messenger === 'unthread';
  const isFin = messenger === 'fin' || messenger === 'agent';

  const unthread = useUnthread({ enabled: isUnthread });
  const intercom = useIntercom({ enabled: isFin });

  if (isUnthread) {
    return {
      openChat: unthread.openChat,
      closeChat: unthread.closeChat,
      toggleChat: unthread.toggleChat,
      openChatWithMessage: noop,
      variant: 'unthread',
    };
  }

  return {
    openChat: intercom.openChat,
    closeChat: intercom.closeChat,
    toggleChat: intercom.toggleChat,
    openChatWithMessage: intercom.openChatWithMessage,
    variant: messenger === 'agent' ? 'agent' : 'fin',
  };
};
